"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = void 0;
var diveGeneratorManager_sidecar_1 = require("@dive/dive-generator/common/diveGeneratorManager-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var uiFps_sidecar_1 = require("@ui/uiFps-sidecar");
var buttons2_sidecar_1 = require("@uiParts/buttons2-sidecar");
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var diveTilemap_renderer_sidecar_1 = require("@voyage/dive/tilemap/diveTilemap_renderer-sidecar");
var voyageBackground_sidecar_1 = require("@voyage/background/voyageBackground-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var voyageCameraStarmap_sidecar_1 = require("@voyage/camera/voyageCameraStarmap-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageBodies_sidecar_1 = require("@voyage/entities/voyageBodies-sidecar");
var voyageBullets_sidecar_1 = require("@voyage/entities/voyageBullets-sidecar");
var voyageCarryable_sidecar_1 = require("@voyage/entities/voyageCarryable-sidecar");
var voyageJettisons_sidecar_1 = require("@voyage/entities/voyageJettisons-sidecar");
var voyageParticles_sidecar_1 = require("@voyage/particles/voyageParticles-sidecar");
var voyageShipSaver_sidecar_1 = require("@voyage/saver/voyageShipSaver-sidecar");
var voyageStarmaps_sidecar_1 = require("@voyage/starmap/voyageStarmaps-sidecar");
var voyageGameManager_sidecar_1 = require("@voyage/game-status/voyageGameManager-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var voyageIndicators_sidecar_1 = require("@voyage/ui-cursors/voyageIndicators-sidecar");
var voyagePicker_sidecar_1 = require("@voyage/ui-cursors/voyagePicker-sidecar");
var voyageMenuMain_sidecar_1 = require("@voyage/ui/voyageMenuMain-sidecar");
var voyageSplatters_sidecar_1 = require("@voyage/particles/voyageSplatters-sidecar");
var diveColors_1 = require("@dive/colors/diveColors");
var diveDebug_sidecar_1 = require("@dive/debug/diveDebug-sidecar");
var diveParticles_sidecar_1 = require("@dive/effects/diveParticles-sidecar");
var diveSlashEffect_sidecar_1 = require("@dive/effects/diveSlashEffect-sidecar");
var diveSplatters_sidecar_1 = require("@dive/effects/diveSplatters-sidecar");
var diveBullets_sidecar_1 = require("@dive/entities/diveBullets-sidecar");
var diveObjects_sidecar_1 = require("@dive/entities/diveObjects-sidecar");
var diveFont_sidecar_1 = require("@dive/fonts/diveFont-sidecar");
var rogueGlyphs_sidecar_1 = require("@dive/fonts/rogueGlyphs-sidecar");
var rogueMonofont_sidecar_1 = require("@dive/fonts/rogueMonofont-sidecar");
var diveMovementIndicators_sidecar_1 = require("@dive/indicators/diveMovementIndicators-sidecar");
var diveMultiplayerCursors_sidecar_1 = require("@dive/indicators/diveMultiplayerCursors-sidecar");
var dive_pathMovementIndicators_sidecar_1 = require("@dive/indicators/dive_pathMovementIndicators-sidecar");
var diveSpyderTilemap_sidecar_1 = require("@dive/spyders/diveSpyderTilemap-sidecar");
var diveTilemapHyperspace_sidecar_1 = require("@dive/tilemap/diveTilemapHyperspace-sidecar");
var imageRecycler_sidecar_1 = require("@dive/to-engine/imageRecycler-sidecar");
var diveUi_messages_sidecar_1 = require("@dive/ui/diveUi_messages-sidecar");
var voyageFloatingText_sidecar_1 = require("@voyage/text/voyageFloatingText-sidecar");
var voyageToolBodyAlign_sidecar_1 = require("@voyage/tools/voyageToolBodyAlign-sidecar");
var voyageProgressBars_sidecar_1 = require("@voyage/ui-cursors/voyageProgressBars-sidecar");
var voyageUiBuyStuff_sidecar_1 = require("@voyage/ui/voyageUiBuyStuff-sidecar");
var voyageUiEditor_sidecar_1 = require("@voyage/ui/voyageUiEditor-sidecar");
var voyageUiGame_sidecar_1 = require("@voyage/ui/voyageUiGame-sidecar");
var voyageUiGameMultiplayer_sidecar_1 = require("@voyage/ui/voyageUiGameMultiplayer-sidecar");
var voyageUiInfoBar_sidecar_1 = require("@voyage/ui/voyageUiInfoBar-sidecar");
var voyageUiLoadShip_sidecar_1 = require("@voyage/ui/voyageUiLoadShip-sidecar");
var voyageUiMessage_sidecar_1 = require("@voyage/ui/voyageUiMessage-sidecar");
var voyageUiMultiListGames_sidecar_1 = require("@voyage/ui/voyageUiMultiListGames-sidecar");
var voyageUiNav_sidecar_1 = require("@voyage/ui/voyageUiNav-sidecar");
var voyageUiPaused_sidecar_1 = require("@voyage/ui/voyageUiPaused-sidecar");
var voyageUiSubsystem_sidecar_1 = require("@voyage/ui/voyageUiSubsystem-sidecar");
var voyageUiTutorial_sidecar_1 = require("@voyage/ui/voyageUiTutorial-sidecar");
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var diveFloatingText_sidecar_1 = require("@dive/text/diveFloatingText-sidecar");
var diveUi_heroesBar_sidecar_1 = require("@dive/ui/diveUi_heroesBar-sidecar");
var diveUi_abilitiesBar_sidecar_1 = require("@dive/ui/diveUi_abilitiesBar-sidecar");
var update = function (time, delta) {
    // let ctx = goatScene.getContext()
    common_sidecar_1.common.setUpdateDelta(delta / 1000);
    var curSpeedScale = 1;
    if (voyageGameManager_sidecar_1.voyageGameManager.get().isPaused) {
        curSpeedScale = 0;
    }
    if (voyageGameStatus_sidecar_1.voyageGameStatus.get().isGameEnded) {
        curSpeedScale = 0;
    }
    common_sidecar_1.common.setUpdateDeltaScaled((delta / 1000) * curSpeedScale);
    if (common_sidecar_1.common.updateFocus()) {
        // Focus changed
        clickEater_sidecar_1.clickEater.tempEat();
    }
    diveSimulationManager_sidecar_1.diveSimulationManager.update();
    imageRecycler_sidecar_1.imageRecycler.resetAll();
    voyageBackground_sidecar_1.voyageBackground.update();
    voyageGameStatus_sidecar_1.voyageGameStatus.update();
    voyageGameManager_sidecar_1.voyageGameManager.update();
    uiFps_sidecar_1.uiFps.update(function (fps) {
        var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
        diveFont_sidecar_1.diveFont.writeAbsolute(gb.width - 30, gb.height - 8, '' + fps, 0.5, diveColors_1.diveColors.pureWhite);
    });
    buttons2_sidecar_1.buttons2.updateAll();
    voyageUiMessage_sidecar_1.voyageUiMessage.update();
    voyageUiMultiListGames_sidecar_1.voyageUiMultiListGames.update();
    voyageMenuMain_sidecar_1.voyageMenuMain.update();
    voyageUiSubsystem_sidecar_1.voyageUiSubsystem.update();
    voyageUiNav_sidecar_1.voyageUiNav.update();
    voyageStarmaps_sidecar_1.voyageStarmaps.updateAll();
    diveSlashEffect_sidecar_1.diveSlashEffect.updateAll();
    voyageBodies_sidecar_1.voyageBodies.updateAll();
    voyageIndicators_sidecar_1.voyageIndicators.updateAll();
    // New ui stuff
    diveUi_heroesBar_sidecar_1.diveUi_heroesBar.update();
    diveUi_abilitiesBar_sidecar_1.diveUi_abilitiesBar.update();
    voyagePicker_sidecar_1.voyagePicker.update();
    // voyageTilemapEditor.update()
    // Dive stuff, new
    diveTilemap_renderer_sidecar_1.diveTilemap_renderer.render();
    if (diveDebug_sidecar_1.diveDebug.debug_viewGenHyperspace) {
        if (diveTilemapHyperspace_sidecar_1.diveTilemapHyperspace.exists()) {
            diveTilemap_renderer_sidecar_1.diveTilemap_renderer.render_generic(diveTilemapHyperspace_sidecar_1.diveTilemapHyperspace.get(), -20, -20);
        }
    }
    diveGeneratorManager_sidecar_1.diveGeneratorManager.update();
    diveObjects_sidecar_1.diveObjects.updateAll();
    diveCrew_sidecar_1.diveCrew.updateAll();
    diveBullets_sidecar_1.diveBullets.updateAll();
    voyageToolBodyAlign_sidecar_1.voyageToolBodyAlign.update();
    voyageCamera_sidecar_1.voyageCamera.update();
    voyageCameraStarmap_sidecar_1.voyageCameraStarmap.update();
    voyageBullets_sidecar_1.voyageBullets.updateAll();
    voyageCarryable_sidecar_1.voyageCarryable.updateAll();
    voyageJettisons_sidecar_1.voyageJettisons.updateAll();
    diveMultiplayerCursors_sidecar_1.diveMultiplayerCursors.updateAll();
    //voyageMovementIndicators.updateAll()
    diveMovementIndicators_sidecar_1.diveMovementIndicators.updateAll();
    voyageUiInfoBar_sidecar_1.voyageUiInfoBar.update();
    voyageUiTutorial_sidecar_1.voyageUiTutorial.update();
    voyageParticles_sidecar_1.voyageParticles.updateAll();
    diveParticles_sidecar_1.diveParticles.updateAll();
    voyageFloatingText_sidecar_1.voyageFloatingText.updateAll();
    diveFloatingText_sidecar_1.diveFloatingText.updateAll();
    voyageUiPaused_sidecar_1.voyageUiPaused.update();
    voyageUiBuyStuff_sidecar_1.voyageUiBuyStuff.update();
    voyageUiLoadShip_sidecar_1.voyageUiLoadShip.update();
    voyageUiEditor_sidecar_1.voyageUiEditor.update();
    dive_pathMovementIndicators_sidecar_1.dive_pathMovementIndicators.updateAll();
    voyageUiGame_sidecar_1.voyageUiGame.update();
    voyageUiGameMultiplayer_sidecar_1.voyageUiGameMultiplayer.update();
    voyageProgressBars_sidecar_1.voyageProgressBars.updateAll();
    diveSplatters_sidecar_1.diveSplatters.updateAll();
    voyageSplatters_sidecar_1.voyageSplatters.updateAll();
    stevieTexts2_sidecar_1.stevieTexts2.updateAll();
    clickEater_sidecar_1.clickEater.updateAll();
    if (!common_sidecar_1.common.getIsFocused()) {
        rogueMonofont_sidecar_1.rogueMonofont.write(1, 1, 'Click to focus');
    }
    // Font testing
    // let y = 10
    // testSentences.forEach((c) => {
    //   rogueMonofont.write(10, y, c)
    //   y += 2
    // })
    rogueGlyphs_sidecar_1.rogueGlyphs.drawAll();
    diveUi_messages_sidecar_1.diveUi_messages.drawAll();
    // diveUi_messagesRecent.open()
    // diveUi_messagesRecent.drawAll()
    voyageShipSaver_sidecar_1.voyageShipSaver.trySave();
    websockets_sidecar_1.websockets.update();
    if (diveDebug_sidecar_1.diveDebug.debug_runSpyders) {
        diveSpyderTilemap_sidecar_1.diveSpyderTilemap.checkObjectsAndCrewLinks();
    }
};
exports.update = update;
